import {
  AnalyticsApi,
  analyticsApiRef,
  ApiFactory,
  configApiRef,
  createApiFactory,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { CompositeAnalyticsClient } from './CompositeAnalyticsClient';
import { DxAnalyticsClient } from './DxAnalyticsClient';
import { SnowplowClient } from './SnowplowClient';

export const createSnowplowApiFactory = (): ApiFactory<
  AnalyticsApi,
  AnalyticsApi,
  {}
> =>
  createApiFactory({
    api: analyticsApiRef,
    deps: { configApi: configApiRef, identityApi: identityApiRef },
    factory: ({ configApi, identityApi }) =>
      new CompositeAnalyticsClient(
        SnowplowClient.new(configApi, identityApi),
        DxAnalyticsClient.new(configApi, identityApi),
      ),
  });
